<template>
  <div class="bloc-plus--item" v-if="facet" :class="{ 'is-active': expanded }">
    <div class="item-header" @click="expanded = !expanded">
      <h4>{{ title }}</h4>
    </div>
    <div class="item-content" v-if="expanded">
      <p v-for="facetValue in facet.searchFacetValue" :key="facetValue.name">
        <input
          :type="type"
          :value="facetValue.label"
          :id="facetValue.name"
          :checked="isChecked(facetValue.label)"
          @change="onInputChange(facetValue.label, $event)"
        />
        <label :for="facetValue.name">{{ facetValue.label }}</label>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    facet: Object,
    type: { type: String, default: "checkbox" },
    modelValue: { type: [Array, String], default: () => [] }
  },
  emits: ["update:modelValue", "change"],
  data: () => ({ expanded: false }),

  methods: {
    isChecked(value) {
        console.log("isChecked", value, this.modelValue)
      return Array.isArray(this.modelValue)
        ? this.modelValue.includes(value)
        : this.modelValue === value
    },
    onInputChange(value, event) {
        console.log("onInputChange", value, event)
      let newValue
      if (Array.isArray(this.modelValue)) {
        if (event.target.checked) {
          newValue = [...this.modelValue, value]
        } else {
          newValue = this.modelValue.filter(v => v !== value)
        }
      } else {
        newValue = value
      }
      this.$emit("update:modelValue", newValue)
      this.$emit("change")
    }
  },
  mounted() {
    // Initial state based on modelValue
    if (Array.isArray(this.modelValue)) {
      this.expanded = this.modelValue.length > 0
    } else {
      this.expanded = !!this.modelValue
    }
  }
}
</script>
<style lang="scss" scoped>

@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";

.bloc-plus--item {
    padding: 14px 15px;
    @include transition-custom();

    h4 {
        margin: 0;
        font-family: $campaign;
        font-size: 15px;
        font-weight: $regular;
        position: relative;
        

        &:after {
            content: "";
            width: 15px;
            height: 8px;
            display: block;
            position: absolute;
            right: 0;
            top: 5px;
            background: url("@/assets/images/dropdown.svg") 0 0 no-repeat transparent;
            cursor: pointer;
        }
    }

    .item-content {
        p {
            margin: 0 0 20px;
            position: relative;

            &:last-child {
                margin: 0;
            }
        }
    }

    label {
        font-size: 12px;
    }

    &.is-active {
        padding: 20px 15px;
        background-color: #fff;
        border-radius: 30px;
        margin-bottom: 20px;

        .item-header {
            margin: 0 0 19px;
        }

        h4{
            &:after {
                transform: rotate(180deg);
            }
        }
    }
}
</style>